<!-- ./components/RulesComponent.vue -->
<template>
  <div class="container">
    <div class="rules">
      <h1>Base Rules</h1>

      <section>
        <h2>Deck Construction & Win Condition</h2>
        <ul>
          <li>Decks contain exactly 40 cards.</li>
          <li>Up to 4 copies of any single card (identical stats & abilities).</li>
          <li>No mulligans—your deck also serves as resources.</li>
          <li>A player loses when they must draw, plot, or mill and have no cards left in their deck.</li>
        </ul>
      </section>

      <section>
        <h2>Turn Structure</h2>
        <ol>
          <li><strong>Refresh</strong>: Untap all cards and refresh defenses.</li>
          <li><strong>Plot</strong>: Reveal the top cards equal to your Insight, choose one to put into your hand, then
            bottom the rest (no “draw” triggers).</li>
          <li><strong>Main Phase 1</strong>: Players alternate priority—play cards or tap resources to take actions.
          </li>
          <li><strong>Combat</strong>:
            <ul>
              <li>Group your attacking fighters by Speed, highest first.</li>
              <li>Players alternate naming targets for that speed group, then all damage in that group is dealt
                simultaneously.</li>
              <li>Proceed to the next‐highest speed group until all have attacked.</li>
            </ul>
          </li>
          <li><strong>Main Phase 2</strong>: Same as Main Phase 1.</li>
          <li><strong>End</strong>: Resolve end‐of‐turn effects; pass priority to the next player.</li>
        </ol>
      </section>

      <section>
        <h2>Playing Cards & Resources</h2>
        <ul>
          <li>Play a card face-up as a fighter or maneuver, or face-down as a land (resource).</li>
          <li>Resources enter tapped and have no abilities unless explicitly stated.</li>
          <li>Each tapped resource provides one energy of its element type.</li>
          <li>Instead of passing, you may play a card or tap a resource to maintain priority.</li>
        </ul>
      </section>

      <section>
        <h2>Front & Back Lines</h2>
        <ul>
          <li><strong>Front Line</strong>: Defends against ground attackers; can attack opposing front line or player.
          </li>
          <li><strong>Back Line</strong>: Cannot defend unless an ability grants reach; can only attack if an ability
            allows.</li>
          <li>Before combat you get one “Move Lines” step—each card may switch between front/back once per turn.</li>
        </ul>
      </section>

      <section>
        <h2>Combat & Damage</h2>
        <ul>
          <li>Attacking taps the fighter; tapped fighters still defend.</li>
          <li>Flying ignores non-flying blockers when choosing attacks; if exhausted it loses flying defensively.</li>
          <li>Ranged can target across lines (up to two apart) and may ignore flying.</li>
          <li>Damage dealt directly to a player mills cards equal to the attacker’s Impact (default 1).</li>
        </ul>
      </section>

      <section>
        <h2>Core Stats & Keywords</h2>
        <ul>
          <li><strong>Attack</strong>: How much damage a fighter deals in combat.</li>
          <li><strong>Defense</strong>: How much damage a fighter can take before it’s destroyed.</li>
          <li><strong>Speed</strong>: Order in which fighters resolve attacks.</li>
          <li><strong>Insight</strong>: Number of cards you reveal during the Plot step.</li>
          <li><strong>Impact</strong>: Number of cards milled when dealing damage to a player.</li>
          <li><strong>Plot</strong>: The step where you reveal Insight cards, choose one to your hand, and bottom the
            rest.</li>
          <li><strong>Charge</strong>: Plays a card tapped as a face-down resource “charge.”</li>
          <li><strong>Heal</strong>: Returns cards from your discard to the bottom of your deck.</li>
          <li><strong>Armor X</strong>: Reduces incoming damage by X each time.</li>
          <li><strong>Melt</strong>: Ignores Armor when dealing damage.</li>
          <li><strong>Truestrike</strong>: Sets defender's health to 1 before dealing damage.</li>
          <!-- add other key mechanics as needed -->
        </ul>
      </section>
    </div>

  </div>
</template>

<script>
export default {
  name: "RulesComponent",
};
</script>

<style scoped></style>